var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyVideoBoard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 429 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 207,
    height: 224,
    fill: "#fff",
    rx: 7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 207,
    height: 224,
    x: 222,
    fill: "#fff",
    rx: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6324C6",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    d: "M15 138h163M236 138h164"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A7B0BE",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M14 157h96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C4CAD4",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M236 157h96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C4CAD4",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M0 105h207",
    opacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#7B899D",
    d: "M136 111a6 6 0 100-11 6 6 0 000 11z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B899D",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M0 105h135"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C4CAD4",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "M222 105h207",
    opacity: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#6324C6",
    d: "M318 67l21-16v-1l-21-16h-2v32l1 1h1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7D41DC",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "M16 197h12M123 197h11"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A7B0BE",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M40 198h46M147 198h46"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7D41DC",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "M238 197h11M344 197h12"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A7B0BE",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M262 198h45M369 198h45"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6324C6",
    strokeLinecap: "round",
    strokeWidth: 10,
    d: "M96 39v23M114 39v23"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21,
    r: 8,
    fill: "#C4CAD4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 21,
    r: 8,
    fill: "#C4CAD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyVideoBoard);
export default __webpack_public_path__ + "static/media/empty-video-board.66ca030e0fe0d513d8933eb59f9e9cbe.svg";
export { ForwardRef as ReactComponent };